import { createDate, isBefore, subtract } from '@lingoda/dates';

export const isIncomingClass = (startDate: string, now: Date = createDate()) =>
    isBefore(now, subtract({ minutes: 5 }, createDate(startDate)));
